export const FLAG_GETTING_DISCOUNT_CODE_AUTHORIZERS =
  'FLAG_GETTING_DISCOUNT_CODE_AUTHORIZERS';
export const GET_DISCOUNT_CODE_AUTHORIZERS = 'GET_DISCOUNT_CODE_AUTHORIZERS';
export const CLEAR_DISCOUNT_CODE_AUTHORIZERS =
  'CLEAR_DISCOUNT_CODE_AUTHORIZERS';
export const GET_DISCOUNT_CODE_AUTHORIZER = 'GET_DISCOUNT_CODE_AUTHORIZER';
export const CLEAR_DISCOUNT_CODE_AUTHORIZER = 'CLEAR_DISCOUNT_CODE_AUTHORIZER';
export const FLAG_DISCOUNT_CODE_AUTHORIZER_ACTIVITY =
  'FLAG_DISCOUNT_CODE_AUTHORIZER_ACTIVITY';
